(function() {
    const resizeObserver = new ResizeObserver((entries) => {
        const e = entries[0].target;

        const els = e.querySelectorAll(".slideshow__two-col-content");
        els.forEach((e) => e.style.removeProperty("--slideshow-mob-content-height"));
        const highestElHeight = Math.max(...[...els].map((e) => e.offsetHeight));
        els.forEach((e) => e.style.setProperty("--slideshow-mob-content-height", `${highestElHeight}px`));
    });

    document.querySelectorAll(".slideshow:has(.slideshow__two-col)").forEach((e) =>
      resizeObserver.observe(e)
    );
})();
